import * as React from 'react';

import * as styles from './Utilities.css';

export const Utilities: React.FC = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
